module.exports = __webpack_public_path__ + "img/logo.626d5e6d.png";